module.exports = __webpack_public_path__ + "static/media/login_bg.262e21d4.png";